const tempData = {
  success: true,
  count: 11,
  allCampaigns: [
    {
      overview: {
        campaignName: "Positive Vibes",
        campaignType: "OPEN",
        description:
          "Welcome to the Positive Vibes Campaign - a way for everyone to get involved and join youth on a mission to support children and young people in need. \n\nHow does it work?\nThere are youth projects around the world that need your help. You can support by buying one of the image impact tokens created by youth and other supporters OR contributing an image that will be sold as an impact token. \n\nIf you buy one of the images, this will be an impact token that builds your impact portfolio that you can share, AND it will also be your token ticket to the Positive Vibes Festival for Youth Day 2024.  If you contribute an image, you can also earn from it if its bought – and it will then be an impact token ticket too.\n\nWe are also working to twin schools and organisations with projects in need. We don't ask for a lot, all you need is a bit of inspiration to create some images or awesome photos that can be contributed to a campaign. Once you have these, add it to a campaign, promote it to your networks to get them supporting AND you earn while supporting a project of your choice while building your impact portfolio! Get in touch at aunuaglobal.org to find out more about how this works, and you can check out some of the projects you could twin with to support here: https://impactoverse.com/browse-sub-campaign/63c42a6b4df378abfe55cd84\n\nWhat will funds from this campaign support?\n1) By October of 2023 we aim to raise $1000 to support at least 10 sub-campaigns aimed at improving the lives of children and young people with their Positive Vibes campaigns so that they can fundraise for their own needs. \n2) By January 2024 we aim to raise $10 000 to build out the ROAR app that supports youth with training and support on their impact journeys, and that also gives them an outlet for their creativity through AUNUA Stage - our youth media programme. We aim to onboard at least 200 children and young people by this time.\n3) By August 2024 we aim to have raised $30 000, (alongside additional sponsorships), to build out the AUNUA Youth Academy in the Metaverse of Impact, giving youth opportunities without borders. \n\nMore on the Positive Vibes Movement:\nAUNUA Global in Partnership with Skyler Jett and his charity Music for Global Change, launched the Positive Vibes Movement which champions more positive action that leads to more positive vibes around the world. What would YOUR world be like with more love and kindness?! Let's find out with Positive Vibes! Find out more on aunuaglobal.com\n\n",
        startDate: "2023-01-15T18:59:14.000Z",
        endDate: "2024-08-31T14:59:14.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1674828850697_653000_Positive-Vibes-Banner.jpg",
        ],
        isSuperCampaign: true,
        isSubCampaign: false,
        superCampaignId: "",
        superCampaignName: "",
        country: "United Kingdom",
      },
      impact: {
        category: "Children",
        milestones: [],
      },
      _id: "63c42a6b4df378abfe55cd84",
      userId: "63c3e0964df378abfe55cc94",
      brandId: "63c3e85f4df378abfe55ccd9",
      causeId: "",
      isFeatured: true,
    },
    {
      overview: {
        campaignName: "A World of Wonder",
        campaignType: "CLOSED",
        description:
          "Many of us have been incredibly lucky to see as much of the world as we have and the more we see the more aware we become of the unique needs and diverse challenges of different places. Adventurelogue was a way to combine the love of travel with a means to give back to the communities and destinations that make traveling so addictive for us. Our proceeds support projects like Project Peru (check out our website for more info https://adventurelogue.co.uk) and if you support with the purchase of an Impact DOTs, we can either donate a travel diary to a refuge or shelter, or we can post it out to you if you're in the UK. Please contact us for shipping costs overseas. Additionally, all Impact DOTs sold on our campaign will also give you access to an online concert and metaverse festival with some great talents (more info coming soon!) and you can find out more here https://www.aunuaglobal.org/positive-vibes",
        startDate: "2023-02-21T20:47:12.000Z",
        endDate: "2023-11-30T17:47:12.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1677007504495_840448_adveturelogue(920Ã411px).png",
        ],
        isSuperCampaign: false,
        isSubCampaign: true,
        superCampaignId: "63c42a6b4df378abfe55cd84",
        superCampaignName: "Positive Vibes",
        country: "United Kingdom",
      },
      impact: {
        category: "International Aid",
        milestones: [],
      },
      _id: "63f51a90c040bbe49f9b0dba",
      userId: "63d6f06a7bf683b8c836c25b",
      brandId: "",
      causeId: "63e004f4c040bbe49f9aff9e",

      isFeatured: false,
    },
    {
      overview: {
        campaignName: "SaferWays Kids",
        campaignType: "CLOSED",
        description:
          "We want the world to be a safer place and are supporting SaferWays (see saferways.info) to develop a program called SaferWays Kids, developing fun info packs that teach kids about safety. In aid of this we are releasing our limited edition Bears. When you buy one of the Bear Impact DOTs you also get a Bear Martial Arts t-shirt shipped out to you. Contact us through bearmartialarts.com with proof of your purchase and we'll arrange shipping, OR we can donate the tee to a local youth project. BONUS: Your Impact DOT also gives you access to the Positive Vibes Festival in August! Check out positivevibesglobal.com for more info and updates. ",
        startDate: "2023-03-20T21:13:58.000Z",
        endDate: "2024-02-19T15:13:58.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1679263703208_968836_f4b94d81-b49b-47f6-9fe9-06cb90155c28.png",
        ],
        isSuperCampaign: false,
        isSubCampaign: true,
        superCampaignId: "63c42a6b4df378abfe55cd84",
        superCampaignName: "Positive Vibes",
        country: "United Kingdom",
      },
      impact: {
        category: "Children",
        milestones: [],
      },
      _id: "6418152cc1877fb6b1264437",
      userId: "63d6eed57bf683b8c836c24a",
      brandId: "",
      causeId: "63e0053fc040bbe49f9affa8",
      isFeatured: false,
    },

    {
      overview: {
        country: "",
        campaignName: "She Hygiene",
        campaignType: "OPEN",
        description:
          "She Hygiene is an initiative by We Rise Together that focuses on distributing bio-degradable sanitary pads to girls and women who cannot afford to buy these basic necessities and we also educate them regarding the importance of menstrual health. \r\n\r\nOur vision is to provide access to eco-friendly sanitary products to reduce the staggering numbers of schoolgirls dropping out because of unhygienic menstruation. We believe menstrual hygiene is a basic right, not a luxury. \r\n\r\nOur monthly target is to provide pads to  300 women and girls, every month, who struggle to practice safe and healthy menstrual hygiene.\r\n\r\nWe have conducted several drives in:\r\nslum areas, girls’ orphanages and  schools teaching deprived girls.\r\n\r\nThrough our educational sessions, we have broken down the taboo surrounding menstruation due to which our target audience is able to freely discuss their period problems and also encourage their friends, sister and mothers to use pads as well. \r\n\r\nThis has reduced their period problems and offered a better menstrual health to many.\r\n\r\nRecently, we have also started promoting the use of other sustainable options like Menstrual Cups.",
        startDate: "2023-03-21T00:03:52.000Z",
        endDate: "2023-12-20T00:03:52.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1679295021370_782963_5bf27f5d-317b-4bc6-a809-27ce66fab31a.jpg",
        ],
        isSuperCampaign: false,
        isSubCampaign: true,
        superCampaignId: "63c42a6b4df378abfe55cd84",
        superCampaignName: "Positive Vibes",
      },
      impact: {
        category: "Health",
        milestones: [],
      },
      _id: "64183c3bc1877fb6b12644ab",
      userId: "641023bdc1877fb6b126390a",
      brandId: "",
      causeId: "640b37dfc1877fb6b1263641",
      isFeatured: false,
    },
    {
      overview: {
        campaignName: "Esther's Orphanage ",
        campaignType: "OPEN",
        description:
          "This is a campaign that is part of the Positive Vibes movement. We hope that you will support us and spread more positive vibes!!\n\nThe Orphanage is run by Esther who first realised what it felt like to be helpless after losing her dad. She was determined to help other children so that they would never need to experience the same struggles that she had.\n\nShe started the orphanage by supporting 3 children and this has grown with her now looking after the needs of 20, from ages 3 upward.   The orphanage, predominantly through Esther, provides support and security of a home for these vulnerable children who are entirely dependent on the orphanage for their education, clothing, food, shelter and well-being. \n\nDespite Esther's noble intentions for these children and to save them from suffering, life is still a struggle as the orphanage is largely dependent on donations which are in short support. Esther is running this campaign to reduce the dependency on donations, to provide a more sustainable solution to the hunger the children face and a long term solution for their well-being. \n\nFood security is important and this campaign is to fundraise for some land, animals and provisions for a vegetable garden so that the orphanage can be more self-sufficient and less reliant on donations. Please support our campaign by buying an image or event contributing an image and sharing with your network. \n\nThis campaign is a part of the Positive Vibes Super Campaign so all Impact DOTs will also give the owners entry to The Positive Vibes Festival in August. More info can be found at aunuaglobal.com. \n\n",
        startDate: "2023-03-20T11:28:58.000Z",
        endDate: "2024-02-29T10:28:58.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1679308253392_667901_b8890f59-3a62-4675-8926-9a8d4f5d47f1.jpg",
        ],
        isSuperCampaign: false,
        isSubCampaign: true,
        superCampaignId: "63c42a6b4df378abfe55cd84",
        superCampaignName: "Positive Vibes",
        country: "Zambia",
      },
      impact: {
        category: "Health",
        milestones: [],
      },
      _id: "6416fb5cc1877fb6b1264098",
      userId: "63c3e0964df378abfe55cc94",
      brandId: "63c3e85f4df378abfe55ccd9",
      causeId: "",
      isFeatured: false,
    },
    {
      overview: {
        campaignName: "Road to Education ",
        campaignType: "OPEN",
        description:
          "We want to buy a school bus for vulnerable kids to help them reach school in the morning. Children from age 3 have to walk over 7km to get to our charity school where we provide free education, meals and resources. \n\nWe need lots of support but we think a bus is a priority to start as these children face many dangers on the walk and some have to leave home at 5am to get to school at 8:30am and then get home at 7:30pm. \n\nA school bus will cost $12,821 and we hope that you will buy the art which will show your support for us and when you buy the kids art it will also be a ticket to the positive vibes festival - see positivevibesglobal.com \n\nWe can make a difference to these children’s lives. ",
        startDate: "2023-05-01T07:26:00.000Z",
        endDate: "2023-12-31T10:30:00.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1680964069102_585789_1a7d6211-d174-41bd-b180-e662d2286e0a.jpg",
        ],
        isSuperCampaign: false,
        isSubCampaign: true,
        superCampaignId: "63c42a6b4df378abfe55cd84",
        superCampaignName: "Positive Vibes",
        country: "Tanzania",
      },
      impact: {
        category: "Education",
        milestones: [],
      },
      _id: "643179e5d001d4fd2f5e63e5",
      userId: "641addefff96c10593df6507",
      brandId: "",
      causeId: "641ee6faff96c10593df779a",
      isFeatured: false,
    },
    {
      overview: {
        campaignName: "Canine Superheroes",
        campaignType: "OPEN",
        description:
          "This is for dog lovers all around the world! And... you don't need to know what an Impact DOT is or how to create one. It's really easy to get involved, all you need is an image of your dog that you love, that will forever be linked to a digital token, (that's the Impact DOT) AND when you buy the Impact DOT you'll be supporting a dog in need, and possibly save it's life. \r\n\r\nThe harsh reality is that euthanasia is common 'solution' for dogs with behavioral issues, often only because they've had limited socialization or training, and because their owners have had limited instruction on how to integrate their fur babies into the world. \r\n\r\nWe want to help give these amazing companions a fighting chance by working with animal shelters to offer training and support for pups and hopefully their new forever humans. \r\n\r\nFor every $300 that we earn from your Impact DOT creations and sales we will support 10 dogs in an animal shelter with socialization and training. 10 % of earnings will also be donated to the animal shelter for other resources that they need. \r\n\r\nSteps to help:\r\n1) Just sign up\r\n2) Verify your account, (you have to get verified through the Stripe payment gateway because on this platform, people can earn from Impact DOT creations and sales too so if you chose to support a campaign and earn from sales they need a way to pay you!\r\n3) On our campaign page, click on Contribute an Impact DOT, and add the details for the image, choose what percentage of the sale you want to give to our campaign, (if you're buying the Impact DOT or you don't want to earn from the sale, please choose 100%), and click on create.\r\n4)Once you've created the image, you can then buy it, or share it with your network for someone else to purchase and support our campaign. \r\n\r\nWe really hope that you will support us on this. The pup you love can help save others! \r\n\r\nP.S. If you want to add some cool effects to your images before you add them, there are lots of free online options to do that, including one called Nightcafe studio (creator.nightcafe.studio) which gives you free credits. ",
        startDate: "2023-05-26T12:23:30.000Z",
        endDate: "2024-03-31T12:23:30.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1682436337463_597427_89e40922-0202-4340-99dd-db6de5cc4dfe.png",
        ],
        isSuperCampaign: false,
        isSubCampaign: true,
        superCampaignId: "64181f64c1877fb6b1264456",
        superCampaignName: "PetDrops",
        country: "United Kingdom",
      },
      impact: {
        category: "Animal Welfare",
        milestones: [],
      },
      _id: "6447f0f11fbc6ac0dfdbdde7",
      userId: "63d6f0d97bf683b8c836c266",
      brandId: "",
      causeId: "63e00bddc040bbe49f9b001d",
      isFeatured: false,
    },

    {
      overview: {
        campaignName: "Water for Life",
        campaignType: "OPEN",
        description:
          "THE CONTEXT:\nWe have come a long way over the last year, and we have the opportunity to do so much more, but trying to get everything done with limited resources and while working as volunteers, has been tough. We have two major initiatives that we would love support on, one that focuses on education and the other on technology. \n\nEDUCATION:\nWith the education program, Embark is interested in working with us so that we might develop an environmental education program. The aim would be  to support students, initially in a pilot followed by a rollout to 38 schools with education, practical skills and collaborative experiences through accelerators and incubators to raise awareness of the challenges, and to accelerate development of solutions. We want to develop this program with them and then be able to support schools and programs everywhere, both in the UK and internationally to do the same, creating a ripple effect of behavioural change and rapid solution deployment. \n\nWe are looking to raise £25 000 to support with the initial development, pilot and rollout of the program. \n\nTECHNOLOGY:\nThe second area that we need support with, is to help us develop technology that will clean rivers and prevent plastic from reaching the ocean. Existing solutions focus just on the river surface, but we are working in partnership to develop a technology that also lifts and captures plastic from the riverbed. We are finalizing this project and will run a separate campaign for this in time, but would love for you to get in touch if you would like to partner, sponsor or support in some other way. \n\nHOW TO GET INVOLVED:\n1) Buy an image, when you do it will be an Impact DOT that will build your impact portfolio and impact profile. Show the world what you stand for.\n2) Share an original image of yours- something that is water themed, it could be a drawing, a photo, some AI art, and promote it so that it sells. Even if it's just for $10, every small amount matters so help us to save the world! NB- YOU CAN EARN FROM IMAGES WHEN THEY SELL & YOU CAN ALSO OFFER BUYERS ADDITIONAL VALUE FROM THE IMAGES (for example anyone who buys the image also gets a physical item, or access to an experience or a product or service).\n3) Run your own sub-campaign under our super campaign to fundraise for water initiatives and programs. Anything that is focused on protecting our water resources, fresh water and salt water... and the ecosystems around them. We want to give you a voice and a means to do this. Remember, you don't need to know anything about Impact DOTs, and you can get others to contribute too. \n\nNote: If you're a school or a youth organisation, run an activity day to fundraise for any of your impact activities and for us too :) You can also get involved in the Positive Vibes Movement. Get in touch to find out more. \n\nFind us at thinkocean.earth\n",
        startDate: "2023-05-01T04:39:17.000Z",
        endDate: "2024-09-30T04:39:17.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1682840487380_582018_3397b0b7-fbfa-49b3-8410-d739cf41a969.png",
        ],
        isSuperCampaign: true,
        isSubCampaign: false,
        superCampaignId: "",
        superCampaignName: "",
        country: "United Kingdom",
      },
      impact: {
        category: "Environment",
        milestones: [],
      },
      _id: "644e1ba84d7c29c3de584700",
      userId: "6409c469c1877fb6b1263492",
      brandId: "",
      causeId: "644d3dbb4d7c29c3de5844a7",
      isFeatured: false,
    },
    {
      overview: {
        campaignName: "Action for Equality",
        campaignType: "OPEN",
        description:
          "About the Cause \nWe’ve come together as a group of refugees to help Afghan girls and young women overcome barriers to access of third level online learning opportunities (for undergraduate and graduate degrees). We have fled from war-torn areas, including Afghanistan and the Ukraine, but now in a safer place, believe that we have to stand up and do what we can to empower others.\n\nIn December 2022, an institutional decision was made through Taliban rule that banned girls and women from being able to access education. No debate or argument or lobbying has as yet changed this. \nWe embody the struggle for women's right, where education is one of the main and primary human rights.  Afghanistan is the only country where girls and women do NOT have the right to study. Any protests are met with threats of physical harm. The psychological harm is constant. \nOur aim is to prevent the girls from extinguishing the dreams in their hearts. Education is the way to a better future and the realization of dreams. This is the main purpose of what we are doing. \nBy supporting our campaign, you open the door for many Afghan girls and women to realize their dreams.  You give a lifeline to hope and faith for a brighter future for them.  You create an opportunity for them to get out of a life of oppression and inequality.  Education should be a right, help us to make this a reality, prove that equality stands a chance. \nWe know that there are many who will say that there are lots of online courses that women can access, and there are also some universities that offer scholarships. This is a great resource BUT there are still barriers to accessing this. Even for those who have the technology, there is limited internet access, not because of internet not being available generally, but lack of funds to purchase data which is expensive. Even for girls who have good proficiency in English, they don’t have the means to get the English tests required that certifies their proficiency and allows for them to overcome this hurdle which is a pre-requisite for the university sponsored positions. We would love to be able to work with universities all around the world to be able to offer accredited opportunities for these girls and women, but to start we need to overcome these initial hurdles. \nWe would like to raise funds for the following:\n- Internet access for 60 girls and young women at $15 per month, for 3 months to complete the English certifications ($900 x 3: Total of $2700)\n- The IELTS test for 60 girls and young women at $200 per person (Total of $12 000) We would also welcome any test provider being able to sponsor these tests and universities and other training providers being able to offer subsidised positions. \nWe understand that there are many challenges but we have to try to make a difference. By supporting us, you support a fairer world, and you take a stand against inequality. \n",
        startDate: "2023-06-08T02:00:00.000Z",
        endDate: "2030-02-07T20:41:55.000Z",
        bannerImageUrl: [
          "public/uploads/identityVerifications/banner_1686181053140_688039_4bb666a5-5074-4673-a355-0dc82a5e496e.jpg",
        ],
        isSuperCampaign: false,
        isSubCampaign: false,
        superCampaignId: "",
        superCampaignName: "",
        country: "Afghanistan",
      },
      impact: {
        category: "Education",
        milestones: [],
      },
      _id: "648114bd2e4e15627b786187",
      userId: "64189faac1877fb6b12645a3",
      brandId: "",
      causeId: "646367692079da1f93a1c2d6",

      isFeatured: false,
    },
  ],
};
const renderCheckboxSection = (
  heading,
  options,
  searchQuery,
  otherOptions,
  setOtherOptions,
  respectiveOption,
  sectionStates,
  sectionIndex
) => {
  const filteredOptions = options.filter((option) =>
    option.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const handleCheckboxChange = (e, setOptions, otherOptions) => {
    const value = e.target.value;
    setOptions((prevOptions) =>
      e.target.checked
        ? [...prevOptions, value]
        : prevOptions.filter((option) => option !== value)
    );
  };
  sectionStates[sectionIndex] = filteredOptions.length > 0;
  const areAllSectionsEmpty = (sectionStates) =>
    sectionStates.every((state) => !state);

  return (
    <div className="px-2">
      {filteredOptions.length > 0 && (
        <h2 className="text-lg font-semibold my-2">{heading}</h2>
      )}
      <ul className="flex flex-col flex-wrap">
        {filteredOptions.map((option) => (
          <li key={option}>
            <label className="checkbox-label">
              <input
                type="checkbox"
                className="h-5 w-5 mr-3 rounded border-jacarta-200 text-accent checked:bg-accent focus:ring-accent/20 focus:ring-offset-0 dark:border-jacarta-500 dark:bg-jacarta-600 "
                value={option}
                checked={
                  otherOptions.includes(option) ||
                  (respectiveOption && respectiveOption.includes(option))
                }
                onChange={(e) =>
                  handleCheckboxChange(e, setOtherOptions, options)
                }
              />
              {option}
            </label>
          </li>
        ))}
      </ul>
      {areAllSectionsEmpty(sectionStates) && (
        <p className=" w-full whitespace-break-spaces">Currently no choices.</p>
      )}
    </div>
  );
};

import React, { useState, useRef, useEffect } from "react";

import { tranding_category_filter } from "../../data/categories_data";
import { HeadLine } from "../../components/component";
import Feature_collections_data from "../../data/Feature_collections_data";
import Collection_dropdown from "../../components/dropdown/collection_dropdown";
import Explore_collection_item from "../../components/collectrions/explore_collection_item";
import Meta from "../../components/Meta";
import { collectCollectionData } from "../../redux/counterSlice";
import { useDispatch } from "react-redux";
import Image from "next/image";
import Collection_category_filter from "../../components/collectrions/collection_category_filter";
import {
  CampaignSvg,
  CountrySvg,
  ImpactCategorySvg,
  SuperCampaignSvg,
} from "../../components/svg/svgFilesGlobal";


const ExploreBrandCampaigns = () => {
  const inputRef = useRef(null);
  const campaignInputRef = useRef(null);
  const superCampaignInputRef = useRef(null);
  const impactCategoryInputRef = useRef(null);
  const countryInputRef = useRef(null);
  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(e.target) &&
        campaignInputRef.current &&
        !campaignInputRef.current.contains(e.target) &&
        superCampaignInputRef.current &&
        !superCampaignInputRef.current.contains(e.target) &&
        impactCategoryInputRef.current &&
        !impactCategoryInputRef.current.contains(e.target) &&
        countryInputRef.current &&
        !countryInputRef.current.contains(e.target)
      ) {
        setDropdownShow(false);
        setSuperCampaignDropdownShow(false);
        setcampaignDropdownShow(false);
        setImpactCategoryDropDownShow(false);
        setCountryDropDownShow(false);
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleInputFocus = () => {
    setDropdownShow(true);
    setSuperCampaignDropdownShow(false);
    setcampaignDropdownShow(false);
    setImpactCategoryDropDownShow(false);
    setCountryDropDownShow(false);
  };
  const [campaignOptions, setCampaignOptions] = useState([]);
  const [superCampaignOptions, setSuperCampaignOptions] = useState([]);
  const [impactCategoryOptions, setImpactCategoryOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);

  const [campaignDropDownShow, setcampaignDropdownShow] = useState(false);
  const [superCampaignDropDownShow, setSuperCampaignDropdownShow] =
    useState(false);
  const [impactCategoryDropDownShow, setImpactCategoryDropDownShow] =
    useState(false);

  const [countryDropDownShow, setCountryDropDownShow] = useState(false);

  const [sortActive, setSortActive] = useState(null);
  const handleSuperCampaignDropdown = () => {
    setcampaignDropdownShow(false);
    setCountryDropDownShow(false);
    setImpactCategoryDropDownShow(false);
    setDropdownShow(false);

    setSuperCampaignDropdownShow(!superCampaignDropDownShow);
  };
  const [selectedCampaignOptions, setSelectedCampaignOptions] = useState([]);
  const [selectedSuperCampaignOptions, setSelectedSuperCampaignOptions] =
    useState([]);
  const [selectedImpactCategoryOptions, setSelectedImpactCategoryOptions] =
    useState([]);
  const [selectedCountryOptions, setSelectedCountryOptions] = useState([]);
  const [searchedValue, setSearchedValue] = useState({});
  const [allData, setAllData] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://api.impactoverse.com/api/app/all-campaigns"
        );
        // const data = await response.json();
        // Resplacing with temparary data
        const data = tempData;
        if (data.success) {
          setAllData(data);
          const uniqueCampaigns = [
            ...new Set(
              data.allCampaigns.map(
                (campaign) => campaign.overview.campaignName
              )
            ),
          ].filter((campaign) => campaign && campaign.trim() !== ""); // Filter null or empty values
          setCampaignOptions(uniqueCampaigns);

          const uniqueSuperCampaigns = [
            ...new Set(
              data.allCampaigns
                .filter((campaign) => campaign.overview.isSuperCampaign)
                .map((campaign) => campaign.overview.campaignName)
            ),
          ].filter((campaign) => campaign && campaign.trim() !== ""); // Filter null or empty values
          setSuperCampaignOptions(uniqueSuperCampaigns);

          const uniqueImpactCategories = [
            ...new Set(
              data.allCampaigns.map((campaign) => campaign.impact.category)
            ),
          ].filter((category) => category && category.trim() !== ""); // Filter null or empty values
          setImpactCategoryOptions(uniqueImpactCategories);

          const uniqueCountries = [
            ...new Set(
              data.allCampaigns.map((campaign) => campaign.overview.country)
            ),
          ].filter((country) => country && country.trim() !== ""); // Filter null or empty values
          setCountryOptions(uniqueCountries);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handlecampaignDropdown = () => {
    setCountryDropDownShow(false);
    setImpactCategoryDropDownShow(false);
    setSuperCampaignDropdownShow(false);
    setDropdownShow(false);

    setcampaignDropdownShow(!campaignDropDownShow);
  };
  const handleImpactCategoryDropdown = () => {
    setcampaignDropdownShow(false);
    setDropdownShow(false);

    setCountryDropDownShow(false);
    setSuperCampaignDropdownShow(false);
    setImpactCategoryDropDownShow(!impactCategoryDropDownShow);
  };
  const handleCountryDropdown = () => {
    setcampaignDropdownShow(false);
    setImpactCategoryDropDownShow(false);
    setDropdownShow(false);

    setSuperCampaignDropdownShow(false);
    setCountryDropDownShow(!countryDropDownShow);
  };
  const handleCheckboxChange = (e, setOptions) => {
    const value = e.target.value;
    setOptions((prevOptions) =>
      e.target.checked
        ? [...prevOptions, value]
        : prevOptions.filter((option) => option !== value)
    );
  };
  const handleRemoveOption = (option, setOptions) => {
    setOptions((prevOptions) =>
      prevOptions.filter((prevOption) => prevOption !== option)
    );
  };

  const [dropdownShow, setDropdownShow] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const sectionStates = [true, true, true, true];

  return (
    <>
      <section className="relative mt-24 lg:pb-48 pb-24">
        <div className="container">
          {/* <!-- Filter --> */}

          {/* <!-- Grid --> */}
          <div className="mb-8 flex flex-wrap items-start justify-between">
            <div className="flex flex-wrap items-center justify-between">
              <div className="flex flex-wrap items-center">
                <div className="my-1 mr-2.5 relative" ref={campaignInputRef}>
                  <button
                    className="group dropdown-toggle dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white"
                    onClick={handlecampaignDropdown}
                  >
                    <CampaignSvg />
                    <span>Campaigns</span>
                  </button>
                  {/* Dropdown Menu */}
                  {campaignDropDownShow && (
                    <div className="z-10 min-w-fit px-2 py-2 w-full dark:bg-jacarta-800 whitespace-nowrap rounded-xl bg-white text-left shadow-xl show absolute top-full">
                      <ul className="flex flex-col flex-wrap">
                        {campaignOptions.map((option) => (
                          <li key={option}>
                            <label className="checkbox-label">
                              <input
                                type="checkbox"
                                value={option}
                                className="h-5 cursor-pointer w-5 mr-3 rounded border-jacarta-200 text-accent checked:bg-accent focus:ring-accent/20 focus:ring-offset-0 dark:border-jacarta-500 dark:bg-jacarta-600"
                                // checked={selectedCampaignOptions.includes(option)}
                                checked={
                                  selectedSuperCampaignOptions.includes(
                                    option
                                  ) || selectedCampaignOptions.includes(option)
                                }
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    setSelectedCampaignOptions
                                  )
                                }
                              />
                              {option}
                            </label>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                <div
                  className="my-1 mr-2.5 relative"
                  ref={superCampaignInputRef}
                >
                  <button
                    className="group dropdown-toggle dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white"
                    onClick={handleSuperCampaignDropdown}
                  >
                    <SuperCampaignSvg />
                    <span>Super Campaigns</span>
                  </button>
                  {/* Dropdown Menu */}
                  {superCampaignDropDownShow && (
                    <div className="z-10 min-w-fit px-2 py-2 w-full dark:bg-jacarta-800 whitespace-nowrap rounded-xl bg-white text-left shadow-xl show absolute top-full">
                      <ul className="flex flex-col flex-wrap">
                        {superCampaignOptions.map((option) => (
                          <li key={option}>
                            <label className="checkbox-label">
                              <input
                                type="checkbox"
                                className="h-5 w-5 mr-3 rounded border-jacarta-200 text-accent checked:bg-accent focus:ring-accent/20 focus:ring-offset-0 dark:border-jacarta-500 dark:bg-jacarta-600"
                                value={option}
                                checked={
                                  selectedSuperCampaignOptions.includes(
                                    option
                                  ) || selectedCampaignOptions.includes(option)
                                }
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    setSelectedSuperCampaignOptions
                                  )
                                }
                              />
                              {option}
                            </label>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                <div
                  className="my-1 mr-2.5 relative"
                  ref={impactCategoryInputRef}
                >
                  <button
                    className="group  dropdown-toggle dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white"
                    onClick={handleImpactCategoryDropdown}
                  >
                    <ImpactCategorySvg />
                    <span>Impact Category</span>
                  </button>
                  {/* Dropdown Menu */}

                  {impactCategoryDropDownShow && (
                    <div className="dropdown-menu ml-2.5 dark:bg-jacarta-800 z-10 min-w-fit px-2 py-2 w-full  whitespace-nowrap rounded-xl bg-white text-left shadow-xl show absolute top-full">
                      <ul className="flex flex-col flex-wrap">
                        {impactCategoryOptions.map((option) => (
                          <li key={option}>
                            <label className="checkbox-label">
                              <input
                                type="checkbox"
                                className="h-5 w-5 mr-3 rounded border-jacarta-200 text-accent checked:bg-accent focus:ring-accent/20 focus:ring-offset-0 dark:border-jacarta-500 dark:bg-jacarta-600"
                                value={option}
                                checked={selectedImpactCategoryOptions.includes(
                                  option
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    setSelectedImpactCategoryOptions
                                  )
                                }
                              />
                              {option}
                            </label>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                <div className="my-1 mr-2.5 relative" ref={countryInputRef}>
                  <button
                    className="group dropdown-toggle dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white"
                    onClick={handleCountryDropdown}
                  >
                    <CountrySvg />
                    <span>Country</span>
                  </button>
                  {/* Dropdown Menu */}
                  {countryDropDownShow && (
                    <div className="dropdown-menu dark:bg-jacarta-800 px-2 py-2 min-w-fit w-full ml-2.5 whitespace-nowrap rounded-xl bg-white text-left shadow-xl show absolute top-full">
                      <ul className="flex flex-col flex-wrap">
                        {countryOptions.map((option) => (
                          <li key={option}>
                            <label className="checkbox-label">
                              <input
                                type="checkbox"
                                className="h-5 w-5 mr-3 rounded border-jacarta-200 text-accent checked:bg-accent focus:ring-accent/20 focus:ring-offset-0 dark:border-jacarta-500 dark:bg-jacarta-600"
                                value={option}
                                checked={selectedCountryOptions.includes(
                                  option
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    setSelectedCountryOptions
                                  )
                                }
                              />
                              {option}
                            </label>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="my-1 mr-2.5 relative " ref={inputRef}>
              <div
                className={`flex h-10 box-border flex-row relative rounded-lg ${
                  dropdownShow ? "border border-accent" : ""
                }`}
              >
                <input
                  onFocus={handleInputFocus}
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className={`
        font-bold text-jacarta-700 rounded-lg placeholder-jacarta-500 w-full py-2 px-1 pl-10
        dark:bg-white/[.15] dark:text-white dark:placeholder-white
        focus:outline-none focus:border-accent focus:border-1 box-border
      `}
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width={20}
                  height={20}
                  className="fill-jacarta-500 h-5 w-5 dark:fill-white absolute left-3 top-1/2 transform -translate-y-1/2"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z" />
                </svg>
              </div>

              {dropdownShow && (
                <div className="dropdown-menu max-h-[300px]  overflow-y-auto dark:bg-jacarta-800 px-2 py-2 min-w-fit w-full ml-2.5 whitespace-nowrap rounded-xl bg-white text-left shadow-xl show absolute top-full">
                  {renderCheckboxSection(
                    "Campaigns",
                    campaignOptions,
                    searchQuery,
                    selectedCampaignOptions,
                    setSelectedCampaignOptions,
                    selectedSuperCampaignOptions,
                    sectionStates,
                    0
                  )}
                  {renderCheckboxSection(
                    "Super Campaigns",
                    superCampaignOptions,
                    searchQuery,
                    selectedSuperCampaignOptions,
                    setSelectedSuperCampaignOptions,
                    selectedCampaignOptions,
                    sectionStates,
                    1
                  )}
                  {renderCheckboxSection(
                    "Impact Category",
                    impactCategoryOptions,
                    searchQuery,
                    selectedImpactCategoryOptions,
                    setSelectedImpactCategoryOptions,
                    null,
                    sectionStates,
                    2
                  )}
                  {renderCheckboxSection(
                    "Countries",
                    countryOptions,
                    searchQuery,
                    selectedCountryOptions,
                    setSelectedCountryOptions,
                    null,
                    sectionStates,
                    3
                  )}
                </div>
              )}
            </div>
            <div className=" w-full mt-7 flex flex-row flex-wrap gap-2 ">
              {selectedCampaignOptions.map((option) => (
                <div
                  key={option}
                  className="selected-option  dark:border-jacarta-600 py-1 dark:bg-jacarta-700    border-jacarta-100 font-display text-jacarta-700 flex items-center gap-3 justify-between rounded-lg border bg-white px-2 text-sm font-semibold   dark:text-white"
                >
                  <p>Campaigns:</p> {option}{" "}
                  <button
                    onClick={() =>
                      handleRemoveOption(option, setSelectedCampaignOptions)
                    }
                  >
                    X
                  </button>
                </div>
              ))}
              {selectedImpactCategoryOptions.map((option) => (
                <div
                  key={option}
                  className=" dark:border-jacarta-600 py-1 dark:bg-jacarta-700    border-jacarta-100 font-display text-jacarta-700 flex items-center gap-3 justify-between rounded-lg border bg-white px-2 text-sm font-semibold   dark:text-white"
                >
                  <p>Impact Category :</p> {option}{" "}
                  <button
                    onClick={() =>
                      handleRemoveOption(
                        option,
                        setSelectedImpactCategoryOptions
                      )
                    }
                  >
                    X
                  </button>
                </div>
              ))}
              {selectedSuperCampaignOptions.map((option) => (
                <div
                  key={option}
                  className="selected-option  dark:border-jacarta-600 py-1 dark:bg-jacarta-700    border-jacarta-100 font-display text-jacarta-700 flex items-center gap-3 justify-between rounded-lg border bg-white px-2 text-sm font-semibold   dark:text-white"
                >
                  <p>Super Campaigns :</p> {option}{" "}
                  <button
                    onClick={() =>
                      handleRemoveOption(
                        option,
                        setSelectedSuperCampaignOptions
                      )
                    }
                  >
                    X
                  </button>
                </div>
              ))}
              {selectedCountryOptions.map((option) => (
                <div
                  key={option}
                  className="selected-option  dark:border-jacarta-600 py-1 dark:bg-jacarta-700    border-jacarta-100 font-display text-jacarta-700 flex items-center gap-3 justify-between rounded-lg border bg-white px-2 text-sm font-semibold   dark:text-white"
                >
                  <p>Country :</p> {option}{" "}
                  <button
                    onClick={() =>
                      handleRemoveOption(option, setSelectedCountryOptions)
                    }
                  >
                    X
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-3 lg:grid-cols-4">
            {allData && (
              <Explore_collection_item
                itemFor="explore-collection"
                selectedCampaigns={selectedCampaignOptions}
                selectedSuperCampaigns={selectedSuperCampaignOptions}
                selectedCountries={selectedCountryOptions}
                selectedImpactCategory={selectedImpactCategoryOptions}
                searchedObject={searchedValue}
                allData={allData}
              />
            )}
          </div>
        </div>
      </section>
    </>
  );
};
export default ExploreBrandCampaigns;
